import React from "react";
import { AiOutlineRetweet } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { newRepost } from "../../redux/actions/postActions";
import formatCount from "../../utils/formatCount";
import { repeatOutline } from "ionicons/icons";
import { IonButton, IonIcon } from "@ionic/react";

const RepostBtn = ({ id, reposts }) => {
  const dispatch = useDispatch();

  const repost = (e) => {
    e.preventDefault();
    dispatch(newRepost(id));
  };

  return (
    <IonButton
      fill="clear"
      onClick={repost}
      className="sidebar-icon display-flex align-items-c post-btns__btn post-btns__reply no-padding-btn ion-no-padding"
    >
      {/* <AiOutlineRetweet /> */}
      <IonIcon icon={repeatOutline} />

      <p>{formatCount(reposts)}</p>
    </IonButton>
  );
};

export default RepostBtn;

